var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 8.88889C35.5556 6.43429 33.5657 4.44444 31.1111 4.44444H8.88889C6.43429 4.44444 4.44444 6.43429 4.44444 8.88889V31.1111C4.44444 33.5657 6.43429 35.5556 8.88889 35.5556H31.1111C33.5657 35.5556 35.5556 33.5657 35.5556 31.1111V8.88889ZM28.8889 22.2222C30.1162 22.2222 31.1111 23.2171 31.1111 24.4444C31.1111 25.6717 30.1162 26.6667 28.8889 26.6667H11.1111C9.88381 26.6667 8.88889 25.6717 8.88889 24.4444C8.88889 23.2171 9.88381 22.2222 11.1111 22.2222H28.8889ZM28.8889 13.3333C30.1162 13.3333 31.1111 14.3283 31.1111 15.5556C31.1111 16.7829 30.1162 17.7778 28.8889 17.7778H11.1111C9.88381 17.7778 8.88889 16.7829 8.88889 15.5556C8.88889 14.3283 9.88381 13.3333 11.1111 13.3333H28.8889ZM40 31.1111C40 36.0203 36.0203 40 31.1111 40H8.88889C3.97969 40 0 36.0203 0 31.1111V8.88889C0 3.97969 3.97969 0 8.88889 0H31.1111C36.0203 0 40 3.97969 40 8.88889V31.1111Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplate);
export default __webpack_public_path__ + "static/media/icon-template.803a2b0870834228c51e34b133c41358.svg";
export { ForwardRef as ReactComponent };